export default __webpack_public_path__ + "static/media/investors.60f8b5f0.png";